import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=24be649c&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24be649c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24be649c')) {
      api.createRecord('24be649c', component.options)
    } else {
      api.reload('24be649c', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=24be649c&scoped=true&", function () {
      api.rerender('24be649c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/pages/NotFound.vue"
export default component.exports